export default ({ COLORS }) => ({
  link: {
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none',
    fontWeight: 'bold'
  },
  date: {
    whiteSpace: 'nowrap'
  },
  center: {
    textAlign: 'center'
  }
})
